import {
  BellAlertIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import {
  CubeTransparentIcon,
  DocumentDuplicateIcon,
  ArrowUpOnSquareStackIcon,
  BanknotesIcon,
  BellIcon,
  BuildingOffice2Icon,
  CalculatorIcon,
  Cog6ToothIcon,
  DocumentArrowUpIcon,
  DocumentPlusIcon,
  DocumentTextIcon,
  HomeIcon,
  LinkIcon,
  MapIcon,
  MapPinIcon,
  PuzzlePieceIcon,
  QuestionMarkCircleIcon,
  RectangleGroupIcon,
  Square2StackIcon,
  Squares2X2Icon,
  SwatchIcon,
  TicketIcon,
  UserIcon,
  WrenchScrewdriverIcon,
  DocumentIcon,
  WrenchIcon,
} from "@heroicons/react/24/solid";
export type sideTabSchema = {
  icon?: JSX.Element;
  name: string;
  path?: string;
  code?: string;
  subTabs?: sideTabSchema[];
};

const SIDE_TABS: sideTabSchema[] = [
  {
    icon: <HomeIcon />,
    name: "Home",
    path: "/home",
    code: "home",
  },
  {
    icon: <BuildingLibraryIcon />,
    name: "Executive Dashboard",
    code: "executive-dashboard",
    path: "/executive-dashboard",
  },
  {
    icon: <BellAlertIcon />,
    name: "Notification Center",
    path: "/notification-center",
    code: "notificationcenter",
  },
  {
    icon: <Squares2X2Icon />,
    name: "Dashboards",
    code: "dashboards",
    subTabs: [
      {
        name: "Card Types",
        path: "/dashboards/card-types",
        code: "card-types",
      },
      {
        name: "Cards",
        path: "/dashboards/cards",
        code: "cards",
      },
      {
        name: "Dashboard",
        path: "/dashboards/dashboard",
        code: "dashboard",
      },
    ],
  },
  {
    icon: <UserIcon />,
    name: "Profile",
    code: "profile",
    path: "/profile",
  },
  {
    icon: <WrenchScrewdriverIcon />,
    name: "User Access",
    code: "user-access",
    subTabs: [
      {
        name: "Roles",
        path: "/user-access/roles",
        code: "roles",
      },
      {
        name: "Users",
        path: "/user-access/users",
        code: "users",
      },
      {
        name: "Permissions",
        path: "/user-access/permissions",
        code: "permissions",
      },
    ],
  },
  {
    icon: <PuzzlePieceIcon />,
    name: "Leads",
    path: "/leads",
    code: "leads",
  },
  {
    icon: <CubeTransparentIcon />,
    name: "Branch Management",
    code: "branch-management",
    subTabs: [
      {
        name: "Branches",
        path: "/branch-management/branches",
        code: "branches",
      },
    ],
  },
  {
    icon: <DocumentDuplicateIcon />,
    name: "Claim Template",
    code: "claim-template",
    path: "/claim-template",
  },
  {
    icon: <DocumentPlusIcon />,
    name: "Proposal Management",
    code: "proposal-management",
    subTabs: [
      {
        name: "Proposal Bulk Upload",
        path: "/proposal-management/proposal-bulk-upload",
        code: "proposal-bulk-upload",
      },
      {
        name: "Certificates",
        path: "/proposal-management/certificates",
        code: "certificates",
      },
      {
        name: "Webhooks",
        path: "/proposal-management/webhooks",
        code: "webhooks",
      },
    ],
  },
  {
    icon: <DocumentArrowUpIcon />,
    name: "Raise Claims",
    code: "raise-claims",
    subTabs: [
      {
        name: "Claims Dashboard",
        path: "/raise-claims/claims-dashboard",
        code: "claims-dashboard",
      },
      {
        name: "Claims Submission",
        path: "/raise-claims/claims-submission",
        code: "claims-submission",
      },
    ],
  },
  {
    icon: <BanknotesIcon />,
    name: "Commission",
    code: "commission",
    subTabs: [
      {
        name: "Commissions",
        path: "/commission/commissions",
        code: "commissions",
      },
      {
        name: "Commission Setting",
        path: "/commission/commission-setting",
        code: "commission-setting",
      },
    ],
  },
  {
    icon: <BuildingOffice2Icon />,
    name: "Partner Management",
    code: "partner-management",
    subTabs: [
      {
        name: "Partner",
        path: "/partner-management/partner",
        code: "partner",
      },
      {
        name: "Partner Roles",
        path: "/partner-management/partner-roles",
        code: "partner-roles",
      },
      {
        name: "Partner Users",
        path: "/partner-management/partner-users",
        code: "partner-users",
      },
      {
        name: "Partner Permissions",
        path: "/partner-management/partner-permissions",
        code: "partner-permissions",
      },
    ],
  },

  {
    icon: <CalculatorIcon />,
    name: "Accounting",
    code: "accounting",
    subTabs: [
      {
        name: "Accounts",
        path: "/accounting/accounts",
        code: "accounts",
      },
      {
        name: "Cash Deposits",
        path: "/accounting/cash-deposits",
        code: "cash-deposits",
      },
      {
        name: "Transactions",
        path: "/accounting/transactions",
        code: "transactions",
      },
    ],
  },
  {
    icon: <TicketIcon />,
    name: "Product Config",
    code: "product-config",
    subTabs: [
      {
        name: "Products",
        code: "products",
        path: "/product-config/products",
      },
      {
        name: "Product Features",
        code: "product-features",
        path: "/product-config/product-features",
      },
    ],
  },
  {
    icon: <DocumentTextIcon />,
    name: "Plan Config",
    code: "plan-config",
    subTabs: [
      {
        name: "Plans",
        path: "/plan-config/plans",
        code: "plans",
      },
      {
        name: "Policies",
        code: "policies",
        path: "/plan-config/policies",
      },
      {
        name: "Policy Features",
        code: "policy-features",
        path: "/plan-config/policy-features",
      },
      {
        name: "Loading",
        code: "loading",
        path: "/plan-config/loading",
      },
      {
        name: "Coupons",
        code: "coupons",
        path: "/plan-config/coupons",
      },
      {
        name: "Combos",
        code: "combos",
        path: "/plan-config/combos",
      },
    ],
  },
  {
    icon: <DocumentIcon />,

    name: "Endorsements",
    code: "endorsements",
    path: "/endorsements",
  },
  {
    icon: <RectangleGroupIcon />,
    name: "Riders",
    path: "/riders",
    code: "riders",
  },
  {
    icon: <ArrowUpOnSquareStackIcon />,
    name: "Rater Config",
    code: "rater-config",
    path: "/rater-config",
  },
  {
    icon: <WrenchIcon />,
    name: "Ic API Config",
    code: "ic-api-config",
    path: "/ic-api-config",
  },
  {
    icon: <LinkIcon />,
    name: "Journey Config",
    code: "journey-config",
    subTabs: [
      {
        name: "Journey Links",
        path: "/journey-config/journey-links",
        code: "journey-links",
      },
    ],
  },
  {
    icon: <Square2StackIcon />,
    name: "Landing Page",
    code: "landing-page",
    subTabs: [
      {
        name: "Broker Landing Page",
        path: "/landing-page/broker-landing-page",
        code: "broker-landing-page",
      },
      {
        name: "Partner Landing Page",
        path: "/landing-page/partner-landing-page",
        code: "partner-landing-page",
      },
    ],
  },
  {
    icon: <SwatchIcon />,
    name: "Masters",
    code: "masters",
    subTabs: [
      {
        path: "/masters/manufacturer",
        name: "Manufacturer",
        code: "manufacturer",
      },
      { path: "/masters/consent", name: "Consent", code: "consent" },
      {
        path: "/masters/fuel-type",
        name: "Fuel Type",
        code: "fuel-type",
      },
      {
        path: "/masters/model",
        name: "Model",
        code: "model",
      },
      {
        path: "/masters/variant",
        name: "Variant",
        code: "variant",
      },
      {
        path: "/masters/insurers",
        name: "Insurers",
        code: "insurers",
      },
      {
        name: "Relations",
        path: "/masters/relations",
        code: "relations",
      },
      {
        name: "Genders",
        path: "/masters/genders",
        code: "genders",
      },
      {
        name: "Payment Mode",
        path: "/masters/payment-mode",
        code: "payment-mode",
      },
      {
        name: "Payment Gateways",
        path: "/masters/payment-gateways",
        code: "payment-gateways",
      },
      {
        name: "Worker Types",
        path: "/masters/worker-types",
        code: "worker-types",
      },
      {
        path: "/masters/business-types",
        name: "Business Types",
        code: "business-types",
      },
      {
        path: "/masters/bank-branches",
        name: "Bank Branches",
        code: "bank-branches",
      },
      {
        name: "Feature Master",
        path: "/masters/feature-master",
        code: "feature-master",
      },
      {
        name: "Feature Categories",
        path: "/masters/feature-categories",
        code: "feature-categories",
      },
      {
        name: "Species",
        path: "/masters/species",
        code: "species",
      },
      {
        name: "Cattle Types",
        path: "/masters/cattle-types",
        code: "cattle-types",
      },
      {
        name: "Entity",
        path: "/masters/entity",
        code: "entity",
      },
      {
        name: "Breeds",
        path: "/masters/breeds",
        code: "breeds",
      },
      {
        name: "Cattle Breeds",
        path: "/masters/cattle-breeds",
        code: "cattle-breeds",
      },
      {
        name: "Occupations",
        path: "/masters/occupations",
        code: "occupations",
      },
      {
        name: "Occupancy Type",
        path: "/masters/occupancy-type",
        code: "occupancy-type",
      },
      {
        name: "Specialization",
        path: "/masters/specialization",
        code: "specialization",
      },
      {
        name: "Commodity Types",
        path: "/masters/commodity-types",
        code: "commodity-types",
      },
      {
        name: "Incoterms",
        path: "/masters/incoterms",
        code: "incoterms",
      },
      {
        name: "Business Nature",
        path: "/masters/business-nature",
        code: "business-nature",
      },
      {
        name: "Event Types",
        path: "/masters/event-types",
        code: "event-types",
      },
      {
        name: "Currency Type",
        path: "/masters/currency-type",
        code: "currency-type",
      },
      {
        name: "Packaging Types",
        path: "/masters/packaging-types",
        code: "packaging-types",
      },
      {
        name: "Segments",
        path: "/masters/segments",
        code: "segments",
      },
      {
        path: "/masters/sub-segment",
        name: "Sub Segment",
        code: "sub-segment",
      },
      {
        name: "Gadgets",
        path: "/masters/gadgets",
        code: "gadgets",
      },
      {
        name: "Claim Types",
        path: "/masters/claim-types",
        code: "claim-types",
      },
      {
        name: "Claim Expenses",
        path: "/masters/claim-expenses",
        code: "claim-expenses",
      },
      {
        name: "Claim Stages",
        path: "/masters/claim-stages",
        code: "claim-stages",
      },
      {
        name: "Property Coverages",
        path: "/masters/property-coverages",
        code: "property-coverages",
      },
      {
        name: "Cancellation Reasons",
        path: "/masters/cancellation-reasons",
        code: "cancellation-reasons",
      },
      {
        name: "Claim Settlement Type",
        path: "/masters/claim-settlement-type",
        code: "claim-settlement-type",
      },
    ],
  },
  {
    icon: <MapPinIcon />,
    name: "Locations",
    code: "locations",
    subTabs: [
      {
        name: "Countries",
        path: "/locations/countries",
        code: "countries",
      },
      {
        name: "States",
        path: "/locations/states",
        code: "states",
      },
      {
        name: "Cities",
        path: "/locations/cities",
        code: "cities",
      },
      {
        name: "Pincodes",
        path: "/locations/pincodes",
        code: "pincodes",
      },
      {
        name: "Block Areas",
        code: "block-areas",
        path: "/locations/block-areas",
      },
      {
        name: "Geo Scopes",
        code: "geo-scopes",
        path: "/locations/geo-scopes",
      },
    ],
  },
  {
    icon: <Cog6ToothIcon />,
    name: "Settings",
    code: "settings",
    subTabs: [
      {
        name: "Themes",
        path: "/settings/themes",
        code: "themes",
      },
      {
        name: "General Settings",
        path: "/settings/general-settings",
        code: "general-settings",
      },
      {
        name: "Add Permissions",
        path: "/settings/add-permissions",
        code: "add-permissions",
      },
      {
        name: "Api Tokens",
        path: "/settings/api-tokens",
        code: "api-tokens",
      },
      {
        name: "Credentials",
        path: "/settings/credentials",
        code: "credentials",
      },
    ],
  },
  {
    icon: <BellIcon />,
    name: "Notifications",
    code: "notifications",
    subTabs: [
      {
        name: "Communication",
        path: "/notifications/communication",
        code: "communication",
      },
      {
        name: "Alert Templates",
        path: "/notifications/alert-templates",
        code: "alert-templates",
      },
      {
        name: "Default Alert Template",
        path: "/notifications/default-alert-template",
        code: "default alert template",
      },
      {
        name: "Alert Logs",
        path: "/notifications/alert-logs",
        code: "alert-logs",
      },
    ],
  },
  {
    icon: <MapIcon />,
    name: "Activity Log",
    path: "/activity-log",
    code: "activity-log",
  },
  {
    icon: <DocumentPlusIcon />,
    name: "Certificate Templates",
    path: "/certificate-templates",
    code: "certificate-templates",
  },
  {
    icon: <DocumentTextIcon />,
    name: "Report Management",
    code: "report-management",
    subTabs: [
      {
        name: "Reports",
        path: "/report-management/reports",
        code: "reports",
      },
    ],
  },
  {
    icon: <QuestionMarkCircleIcon />,
    name: "Questionnaire",
    code: "questionnaire",
    subTabs: [
      {
        name: "Knockouts",
        path: "/questionnaire/knockouts",
        code: "knockouts",
      },
      {
        name: "Medical Questions",
        path: "/questionnaire/medical-questions",
        code: "medical questions",
      },
    ],
  },
  {
    icon: <QuestionMarkCircleIcon />,
    name: "All Segments",
    path: "/all-segments",
    code: "all-segments",
  },
];
export { SIDE_TABS };
